__turbopack_context__.v({
  "skeleton": "TripPriceSkeleton-module__l-rWBW__skeleton",
  "tripPriceSkeletonPulse": "TripPriceSkeleton-module__l-rWBW__tripPriceSkeletonPulse",
});
